module.exports = __webpack_public_path__ + "static/img/p002.61ff2a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/p002.png
// module id = y2am
// module chunks = 0